import React from "react";
import {sendRequest} from "../../../utils/request";
import ComponentConfig from "../../form/ComponentConfig";
import isEqual from "lodash-es/isEqual";
import {get, set} from "../../../utils/dotutils";
import PropsProxy from "../../layout/PropsProxy";
import PropTypes from "prop-types";

class AvailablePaymentProvidersComponent extends React.Component {

    static propTypes = {
        values: PropTypes.any,
        uniqueId: PropTypes.any,
        provideAs: PropTypes.string
    }

    state = {
        availablePaymentProviders: []
    }

    componentDidMount() {
        this.loadProviders();
    }

    componentWillUnmount() {
        this.availablePayments && this.availablePayments.abort();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            !isEqual(get(prevProps, "values.pos.id"), get(this.props, "values.pos.id"))
            ||
            !isEqual(get(prevProps, "values.shipping.serviceprovider_type"), get(this.props, "values.shipping.serviceprovider_type"))
            ||
            !isEqual(prevProps.uniqueId, this.props.uniqueId)
        ) {
            this.loadProviders();
        }
    }

    loadProviders = () => {
        this.availablePayments && this.availablePayments.abort();
        if (get(this.props, "values.pos.id") && get(this.props, "values.shipping.serviceprovider_type")) {
            this.availablePayments = sendRequest({
                option: "componentlist",
                component: "PaymentServiceProvider",
                filter: [
                    {field: "pos", value: get(this.props, "values.pos.id")},
                    {field: "shipping", value: get(this.props, "values.shipping.serviceprovider_type")},
                ],
                order: [{expression: "FIELD({{id}}, '" + this.props.paymentConfig.objects.join("', '") + "')"}]
            });
            this.availablePayments.then((response) => {
                this.setState({
                    availablePaymentProviders: response.items
                });
            });
        } else {
            this.setState({
                availablePaymentProviders: []
            });
        }
    }

    render() {
        const props = {...this.props};
        set(props, this.props.provideAs || "availablePaymentProviders", [...this.state.availablePaymentProviders]);
        delete props.provideAs;
        props.proxy = props.children.type.name;
        return (
            <PropsProxy {...props}>
                {this.props.children}
            </PropsProxy>
        );
    }
}

const AvailablePaymentProviders = (props) => <ComponentConfig componentName="payment" componentConfigAs="paymentConfig">
    <AvailablePaymentProvidersComponent {...props} />
</ComponentConfig>

AvailablePaymentProviders.propTypes = {
    values: PropTypes.any,
    uniqueId: PropTypes.any,
};

export default AvailablePaymentProviders;
